class ProductSectionAnchors extends HTMLElement {  
  constructor() {
    super();

    this.selectors = {
      anchorsContainer: '[data-anchors-container]',
      headerSection: '[data-header-section]',
      sectionAnchor: '[data-section-anchor]',
      sectionAnchorWrapper: '[data-section-anchor-wrapper]',
      sectionAnchors: '[data-section-anchors]',
      sectionAnchorsToggle: '[data-section-anchors-toggle]',
      stickyAnchorsContainer: '[data-sticky-anchors-container]'
    };
  
    this.classes = {
      active: 'active'
    };

    this.$headerSection = document.querySelector('sticky-header')
    this.$anchorsContainer = this.querySelector(this.selectors.anchorsContainer);
    this.$stickyAnchorsContainer = this.querySelector(this.selectors.stickyAnchorsContainer);
    this.$stickySectionAnchor = this.$stickyAnchorsContainer.querySelectorAll(this.selectors.sectionAnchor);    
    this.$sectionAnchor = this.querySelectorAll(this.selectors.sectionAnchor);
    this.$sectionAnchorsToggle = this.querySelector(this.selectors.sectionAnchorsToggle);
  
    this.$sections = [];

    this._setStickySpacing();
    this._prepareAnchorChange();
    this._initEvents();
    
  }

  _initEvents() {
    this.$sectionAnchor.forEach($sa => $sa.addEventListener('click', this._onAnchorClick.bind(this)));
    this.$sectionAnchorsToggle.addEventListener('click', this._toggleAnchors.bind(this));
    window.addEventListener('scroll', throttle(this._onScroll, 50), { passive: true });
  }

  _onAnchorClick(e) {
    e.preventDefault();
    const $anchor = e.currentTarget;
    const targetId = $anchor.getAttribute('href').replace('#', '');
    const $target = document.getElementById(targetId);
    const topSpacing = this.$headerSection ? this.$headerSection.offsetHeight : 0;

    if (!$target) return;

    this._setActiveAnchors(targetId);

    if (
      $anchor.closest(this.selectors.stickyAnchorsContainer) &&
      $anchor.closest(this.selectors.sectionAnchors).classList.contains(this.classes.active)
    ) {
      $anchor.closest(this.selectors.sectionAnchors).classList.remove(this.classes.active);
    }

    window.scrollTo({
      top: $target.getBoundingClientRect().top + window.pageYOffset - topSpacing,
      behavior: 'smooth'
    });
    
  }
  
  _toggleAnchors(e) {
    const target = e.currentTarget;
    target.closest(this.selectors.sectionAnchors).classList.toggle(this.classes.active);
  }

  _setStickySpacing() {
    if (this.$headerSection) {
      this.$stickyAnchorsContainer.style.setProperty('--top-spacing', 'var(--header-height, 71px)');
    } else {
      this.$stickyAnchorsContainer.style.setProperty('--top-spacing', '0px');
    }
  }
  
  _prepareAnchorChange() {
    if (!this.$stickySectionAnchor.length) return;

    this.$stickySectionAnchor.forEach($sa => {
      const sectionId = $sa.getAttribute('href').replace('#', '');
      const $section = document.getElementById(sectionId);

      if ($section) {
        this.$sections.push($section);
      }
      
    });
    
  }

  _percentageWithinViewport($element) {
    const elementTop = $element.getBoundingClientRect().top + window.pageYOffset;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const spaceTop = elementTop - scrollTop;
    const elementHeight = $element.offsetHeight;
    const screenHeight = window.innerHeight;
    const scrollBottom = scrollTop + screenHeight;
    const bottomElement = elementTop + elementHeight;
    const spaceBottom = bottomElement - scrollBottom;
    let heightInScreen = elementHeight - spaceBottom;
    let percentage;

    if (spaceTop < 0) {
        heightInScreen -= spaceTop * -1;
    }

    if (spaceBottom < 0) {
        heightInScreen -= spaceBottom * -1;
    }

    percentage = heightInScreen / screenHeight * 100;
    percentage = percentage < 0 ? 0 : percentage;

    return percentage;
  }

  _onScroll = () => {
    this._toggleStickyAnchors();
    this._checkActiveAnchor();
  }

  _toggleStickyAnchors() {
    const headerHeight = this.$headerSection ? this.$headerSection.offsetHeight : 0;
    const threshold = this.$anchorsContainer.getBoundingClientRect().bottom - headerHeight;
    this.$stickyAnchorsContainer.classList.toggle(this.classes.active, threshold < 0);
  }
  
  _checkActiveAnchor() {
    let highestPercentage = 0;
    let $activeSection;

    for (var index in this.$sections) {
      let $section = this.$sections[index];
      let percentageWithinViewport = this._percentageWithinViewport($section);

      if (percentageWithinViewport > highestPercentage) {
        highestPercentage = percentageWithinViewport;
        $activeSection = $section;       
      }
    }

    if (!highestPercentage) {
      this._removeActiveAnchors();
    } else {
      let id = $activeSection.getAttribute('id').replace('#', '');
      this._setActiveAnchors(id);
    }     
      
  }

  _setActiveAnchors(sectionId) {
    this.$sectionAnchor.forEach($sa => {
      if ($sa.getAttribute('href') === `#${sectionId}`) {
        $sa.classList.add(this.classes.active);
        $sa.closest(this.selectors.sectionAnchorWrapper).style.order = '-1';
      } else if ($sa.classList.contains(this.classes.active)) {
        $sa.classList.remove(this.classes.active);
        $sa.closest(this.selectors.sectionAnchorWrapper).style.order = '';
      }
    });    
  }

  _removeActiveAnchors() {
    this.$sectionAnchor.forEach($sa => {
      $sa.classList.remove(this.classes.active);
    });
  }
    
};

customElements.define('product-section-anchors', ProductSectionAnchors);